import { constants } from "../constants"


const fetchWithTimeout = async (resource, options = {}, timeOut = 30000) => {
    
    const { base } = constants.api
    const endpoint = `${base}/api/${resource}`
    // console.log(endpoint)
    options.headers.Accept = 'application/json'
    
    let aborted = false
    
    try {

        const { timeout = timeOut } = options
        const controller = new AbortController()
        const id = setTimeout(() => { 
            controller.abort() 
            aborted = true
        }, timeout)
        
        const response = await fetch(endpoint, {
            ...options,
            signal: controller.signal
        })

        const status = response?.status

        // console.log('status ', status)

        if(status === 401){
            return {
                code : 401,
                msg : 'Tu sesión ha expirado, por favor vuelve a iniciar sesión.',
                type : 'error'
            }
        }
        if(status === 403){
            return {
                code : 403,
                msg : 'No tienes permiso para acceder al recurso o realizar la acción solicitada.',
                type : 'error'
            }
        }
        if(status === 404){
            return {
                code : 404,
                msg : 'No pudimos localizar el recurso o realizar la acción solicitada.',
                type : 'error'
            }
        }
        if(status === 500){
            return {
                code : 500,
                msg : '¡Lo Sentimos! Ha ocurrido un error interno al procesar la petición.',
                type : 'error'
            }
        }

        clearTimeout(id)
        try {
            const data = await response.json()
            return data
        } catch (err) {
            console.log('err 1', err)
            return {
                type: 'error',
                code: 999,
                msg: `Lo sentimos, ocurrió un error al procesar la respuesta, intenta de nuevo o contacta a soporte técnico.`
            }
        }
    } catch (err) {
        // console.log('err 2', err)
        if(aborted){
            return {
                type: 'error',
                code: 900,
                msg: `¡Tiempo Excedido! Por favor asegúrate que cuentas con una conexión a internet activa.`
            }
        }
        return {
            type: 'error',
            code: 900,
            msg: `No fue posible completar la solicitud, asegúrate que cuentas con una conexión a internet activa.`
        }
    }
}

export { fetchWithTimeout }